// "IC Reporting" - internal Investment-Committee analyses, distinct from the
// Compartment/Platform Reports elsewhere in this app (see the Exaloan
// glossary - Compartment Report / Platform Report / IC Report are three
// different things). Ported from reporting-hub/frontend/src/components/
// preflight/report/IcReportingShell.tsx. Each analysis is its own
// independent card rather than a shared multi-section framework -
// "Deployment", "Investment Ratio", "Delta Net Impairment" today, more to
// follow the same pattern (see each card's own file for what it renders and
// which endpoint feeds it).
//
// This is internal IC analysis, not a Compartment/Platform Report figure -
// still flag any yield/return/performance number surfaced here as
// indicative/pending compliance review before it leaves Exaloan internally,
// per the standing regulatory note (Exaloan is a tied agent of FIDUS Finanz
// AG under FIDUS's BaFin license).

import React from 'react';
import DeploymentChartCard from './DeploymentChartCard';
import InvestmentRatioCard from './InvestmentRatioCard';
import DeltaNetImpairmentCard from './DeltaNetImpairmentCard';

const IcReportingShell = ({ reportingId }) => {
  if (!reportingId) return null;
  return (
    <div>
      <DeploymentChartCard reportingId={reportingId} />
      <InvestmentRatioCard reportingId={reportingId} />
      <DeltaNetImpairmentCard reportingId={reportingId} />
    </div>
  );
};

export default IcReportingShell;
